import React, { FC } from "react";
import { Link } from "react-router-dom";
import Badge from "shared/Badge/Badge";
import NcImage from "shared/NcImage/NcImage";
import PostCardMeta from "components/PostCardMeta/PostCardMeta";
import { BlogPost, BlogCategory } from "data/types";

export interface BlogPostCardProps {
    className?: string;
    size?: "default" | "small";
    data: BlogPost;
}

const BlogPostCard: FC<BlogPostCardProps> = ({
     size = "default",
     className = "",
     data
 }) => {
    const { featuredImage, title, categories } = data;

    const renderSliderGallery = () => {
        return (
            <div className="relative w-full rounded-2xl overflow-hidden">
                <div className="aspect-w-16 aspect-h-9 ">
                    <NcImage
                        containerClassName="flex items-center justify-center"
                        className="w-full"
                        src={featuredImage}
                    />
                </div>
            </div>
        );
    };

    const renderContent = () => {
        return (
            <div className={size === "default" ? "p-5  space-y-4" : "p-3  space-y-2"}>
                <div className="space-y-2">
                    <div className="flex items-center space-x-2">
                        <h2
                            className={`  capitalize ${
                                size === "default" ? "text-xl font-medium" : "text-base font-medium"
                            }`}
                        >
                            <span
                                className="line-clamp-2 leading-6 min-h-[3rem]"
                                title={title}
                            >
                                {title}
                            </span>
                        </h2>
                    </div>
                </div>
                <div className="w-14  border-b border-neutral-100 dark:border-neutral-800"></div>
                <div className="flex flex-wrap items-center gap-2 text-neutral-500 dark:text-neutral-400 text-sm min-h-[32px]">
                    {categories.map((category: BlogCategory) => (
                        <Badge
                            key={category.id}
                            name={category.category}
                            color={category.color}
                            className="capitalize"
                        />
                    ))}
                </div>
                <div className="flex justify-between items-center">
                    <div className="mt-auto hidden sm:block">
                        <PostCardMeta meta={{ ...data }} />
                    </div>
                </div>
            </div>
        );
    };

    return (
        <Link
            to={`/blog-single/${data.id}`}
            className={`nc-BlogPostCard group cursor-pointer relative border border-neutral-200 dark:border-neutral-700 rounded-2xl overflow-hidden hover:shadow-xl transition-shadow bg-white dark:bg-neutral-900 will-change-transform ${className}`}
            data-nc-id="BlogPostCard"
        >
            <div className="flex flex-col">
                {renderSliderGallery()}
                {renderContent()}
            </div>
        </Link>
    );
};

export default BlogPostCard;